var _defs, _path, _path2, _polygon, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNovapointNoiseSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}.cls-2{fill:#009ad9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NovapointNoise_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,24c0,2.9,1.72,5.32,4,5.88V18.12C1.72,18.68,0,21.1,0,24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,19.23a4.62,4.62,0,0,0-2-1.11V29.88a4.62,4.62,0,0,0,2-1.11Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.86 29.76 11.93 20.05 10.51 25.09 9.55 24.82 12.09 15.76 14.16 26.15 15.96 21.42 17.89 25.63 20.01 16.97 22.41 25.82 21.45 26.08 20.06 20.97 18.18 28.66 16.04 24.01 13.86 29.76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.93,2.5A2,2,0,0,0,20,1H12a2,2,0,0,0-1.93,1.5A9,9,0,0,0,4,11v7.12a4.23,4.23,0,0,1,2,0V11a7,7,0,0,1,4.61-6.57A2,2,0,0,0,12,5h8a2,2,0,0,0,1.39-.57A7,7,0,0,1,26,11v7.14a3.91,3.91,0,0,1,2,0V11A9,9,0,0,0,21.93,2.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,28.79a4.54,4.54,0,0,0,2,1.07V18.14a4.54,4.54,0,0,0-2,1.07Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28,18.12V29.88c2.28-.56,4-3,4-5.88S30.28,18.68,28,18.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovapointNoiseSvg);
export default __webpack_public_path__ + "static/media/NovapointNoise_svg.64db43d395257a5aac1957d67ec0543a.svg";
export { ForwardRef as ReactComponent };